import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlTree } from '@angular/router';
import { CompanyModuleService } from '@web-frontend/shared/services/company';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanyModuleGuard implements CanLoad {
  constructor(private companyModuleService: CompanyModuleService) {}

  canLoad(route: Route): Observable<boolean | UrlTree> {
    const { modules = [] } = route.data;

    return this.companyModuleService.activeModules$.pipe(
      filter((activeModules) => activeModules !== null),
      take(1),
      map((activeModules) => {
        return activeModules.some((activeModule) =>
          modules.includes(activeModule.id)
        );
      }),
      tap((res) => {
        if (!res) {
          this.companyModuleService.goFirstRouteActive();
        }
      })
    );
  }
}
